import { render, staticRenderFns } from "./CustomerTransactionsList.vue?vue&type=template&id=36cedfed&scoped=true&"
import script from "./CustomerTransactionsList.vue?vue&type=script&lang=js&"
export * from "./CustomerTransactionsList.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTransactionsList.vue?vue&type=style&index=0&id=36cedfed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cedfed",
  null
  
)

export default component.exports